(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["incador-sticky-scroll-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseStoryScroll = (root) => {
      if (!root || root.dataset.storyScrollInitialised === 'true') return;

      const steps = Array.from(root.querySelectorAll('[data-story-step]'));
      const content = root.querySelector('.story-scroll__content');

      if (!steps.length || !content) return;

      root.dataset.storyScrollInitialised = 'true';

      const setActive = (index) => {
        const safeIndex = Math.max(0, Math.min(index, steps.length - 1));

        steps.forEach((step, stepIndex) => {
          step.classList.toggle('is-active', stepIndex === safeIndex);
        });


        const progress = steps.length > 1
          ? (safeIndex / (steps.length - 1)) * 100
          : 100;

        content.style.setProperty('--story-progress', `${progress}%`);
      };

      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntries = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => {
              const viewportCentre = window.innerHeight / 2;
              const aCentre = a.boundingClientRect.top + (a.boundingClientRect.height / 2);
              const bCentre = b.boundingClientRect.top + (b.boundingClientRect.height / 2);

              return Math.abs(aCentre - viewportCentre) - Math.abs(bCentre - viewportCentre);
            });

          if (!visibleEntries.length) return;

          const nextIndex = Number(visibleEntries[0].target.dataset.storyStep);
          setActive(nextIndex);
        },
        {
          root: null,
          rootMargin: '-42% 0px -42% 0px',
          threshold: 0
        }
      );

      steps.forEach((step) => observer.observe(step));
      setActive(0);

      document.addEventListener('shopify:block:select', (event) => {
        if (!document.documentElement.contains(root)) return;

        const selectedIndex = steps.findIndex(
          (step) => step.dataset.blockId === event.detail.blockId
        );

        if (selectedIndex === -1) return;

        setActive(selectedIndex);
        steps[selectedIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    };

    document
      .querySelectorAll('.story-scroll')
      .forEach((root) => initialiseStoryScroll(root));

    document.addEventListener('shopify:section:load', (event) => {
      const loadedRoot = event.target.matches?.('.story-scroll')
        ? event.target
        : event.target.querySelector?.('.story-scroll');

      initialiseStoryScroll(loadedRoot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
